export default __webpack_public_path__ + "static/media/incomplete.f3fe6e7d.svg";